module.exports = __webpack_public_path__ + "static/img/sign.312803d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/about/sign.jpg
// module id = 5dhd
// module chunks = 1